import axios from 'axios';

import { USER_PREFERENCE } from 'RestAPIs/endpoints';

export const savePreference = (body: [{ key: string; value: string }]) =>
  axios.post(USER_PREFERENCE, body);
